import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls =
  "w-full bg-white border border-black/15 px-4 py-3 text-sm outline-none focus:border-[#FF5508] transition-colors";

export const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) return setError("La contraseña debe tener al menos 8 caracteres.");
    if (pwd !== confirm) return setError("Las contraseñas no coinciden.");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pwd });
      setDone(true);
      toast.success("Contraseña actualizada");
      setTimeout(() => navigate("/admin"), 1500);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "El enlace es inválido o ya expiró.");
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F5F6] flex items-center justify-center px-6">
      <form
        data-testid="reset-password-form"
        onSubmit={submit}
        className="w-full max-w-sm bg-white border border-black/10 p-8 shadow-[0_20px_60px_rgba(0,0,0,0.08)]"
      >
        <Logo className="h-12 w-12 rounded-full object-cover mb-6" />
        <h1 className="font-display text-3xl uppercase font-semibold text-[#111418] mb-1">Nueva contraseña</h1>
        <p className="text-black/50 text-sm mb-6">Elige una contraseña nueva para tu panel.</p>
        {done ? (
          <p data-testid="reset-success" className="text-sm text-black/70">
            Listo. Redirigiendo al inicio de sesión…
          </p>
        ) : (
          <>
            <div className="flex flex-col gap-4">
              <input
                data-testid="reset-password-input"
                type="password"
                required
                minLength={8}
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                placeholder="Nueva contraseña"
                className={inputCls}
              />
              <input
                data-testid="reset-password-confirm"
                type="password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Confirmar contraseña"
                className={inputCls}
              />
            </div>
            {error && (
            <p data-testid="reset-password-error" className="text-[#FF5508] text-xs mt-4">
                {error}
              </p>
            )}
            <button
              data-testid="reset-password-submit"
              type="submit"
              className="w-full mt-6 bg-black text-white text-xs py-4 hover:bg-[#FF5508] transition-colors"
            >
              Guardar contraseña
            </button>
          </>
        )}
      </form>
    </div>
  );
};
